// react-bootstrap components
import { useContext, useState, useRef, useEffect, useCallback } from "react";
import axios from "axios";
import { Container } from "react-bootstrap";
import Linkify from "react-linkify";

import "../../scss/pages/Conversation.scss";
import useAuthorization from "../../hooks/useAuthorization";
import { useSelector } from "react-redux";
import { selectUser } from "../../features/user/userSlice";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { RequestContext } from "../../contexts";
import AlertModal from "./AlertModal";

import MediatorAvatar from "../../assets/images/mediator-avatar.png";
import DoctorAvatar from "../../assets/images/doctor-avatar.png";
import { useMsal } from "@azure/msal-react";
import { createAxiosInstance } from "../../utils/axios-instance";
import { useLocation } from "react-router-dom";
import { use } from "react";

dayjs.extend(utc);

const Conversation = ({ request }) => {
  const { instance, accounts } = useMsal();
  const [message, setMessage] = useState("");
  const [isSending, setIsSending] = useState(false);
  const user = useSelector(selectUser);
  const location = useLocation();

  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);
  const messagesEnd = useRef(null);

  const [conversation, setConversation] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');

  const fetchMessages = useCallback(() => {
    axios
      .get(
        process.env.REACT_APP_API_ENDPOINT +
          "compliance/request/inbox/" +
          request.requestToken
      )
      .then((resp) => {
        setConversation(resp.data);
      });
  }, []);

  const handleCloseSuccess = () => {
    setShowSuccess(false);
  };

  const handleCloseError = () => {
    setShowError(false);
  };

  const transformMessage = (message) => {
    return message.replace(/https?:\/\/[^ ]+/, function (match) {
      return `<a target=_blank href=${match}>${match}</a>`;
    });
  };

  const sendMessage = async () => {
    setIsSending(true);
    var timeStamp = dayjs.utc();
    const payload = {
      requestToken: request.requestToken,
      message: message,
      requestInboxType: location.pathname.includes("mediator")
        ? "MEDIATOR"
        : user?.userRole || "DOCTOR",
      createdDate: timeStamp.local().format(),
    };

    // Attempt to acquire an access token using MSAL and include it in the
    // Authorization header if available. If no user/account is present or
    // token acquisition fails, fall back to sending the request without headers.
    const url = process.env.REACT_APP_API_ENDPOINT + "compliance/request/inbox";

    try {
      let headers = null;

      if (accounts && accounts.length > 0 && instance) {
        const tokenRequest = {
          // try to use an API scope if provided, otherwise use the client id
          scopes: [process.env.REACT_APP_API_SCOPE || process.env.REACT_APP_MSAL_CLIENT_ID || "openid"],
          account: accounts[0],
        };

        try {
          // silent first
          const resp = await instance.acquireTokenSilent(tokenRequest);
          if (resp && resp.accessToken) {
            headers = { Authorization: `Bearer ${resp.accessToken}` };
          }
        } catch (silentError) {
          try {
            // fallback to interactive if silent fails
            const resp = await instance.acquireTokenPopup(tokenRequest);
            if (resp && resp.accessToken) {
              headers = { Authorization: `Bearer ${resp.accessToken}` };
            }
          } catch (popupError) {
            // Could not acquire token; proceed without headers
            console.warn("MSAL token acquisition failed, sending request without Authorization header.", popupError);
          }
        }
      }

      if (headers) {
        await axios.post(url, payload, { headers });
      } else {
        await axios.post(url, payload);
      }

      setMessage("");
      fetchMessages();
      setShowSuccess(true);
      setIsSending(false);
    } catch (err) {
      setMessage("");
      setIsSending(false);
      const serverMessage = err?.response?.data?.message
          || err?.response?.data?.error
          || err?.response?.data
          || '';
      const message = err?.message || 'An unexpected error occurred';
      setErrorMessage(serverMessage ? `${message}: ${serverMessage}` : message);
      setShowError(true);
    }
  };

  useEffect(() => {
    fetchMessages();
  }, [fetchMessages]);

  useEffect(() => {
    if (conversation && conversation.length > 0) {
      var topPos = messagesEnd.current?.offsetTop;
      document.getElementById("scrolling_div").scrollTop = topPos;
    }
  }, [conversation]);

  return (
    <>
      <Container fluid className="mt-20">
        <div className="panel messages-panel">
          <div className="message-chat">
            {conversation.length > 0 && (
              <div className="chat-body" id="scrolling_div">
                {conversation.map((con, i) => (
                  <div
                    key={i}
                    className={
                      con.requestInboxType !== "DOCTOR"
                        ? "message mediator-message"
                        : "message doctor-message"
                    }
                  >
                    <img
                      alt=""
                      className="img-circle medium-image"
                      src={
                        con.requestInboxType !== "DOCTOR"
                          ? MediatorAvatar
                          : DoctorAvatar
                      }
                    />
                    <div className="message-body">
                      <div className="message-info">
                        <h4> {con.createdBy} </h4>
                        <h5>
                          {" "}
                          <i className="fa fa-clock"></i>{" "}
                          {dayjs(con.createdDate)
                            .subtract(5, "hour")
                            .format("MM-DD-YYYY h:mm A")}
                        </h5>
                      </div>
                      <hr />
                      {/* <div className="message-text" dangerouslySetInnerHTML={{__html: transformMessage(con.message)}}/> */}
                      <Linkify
                        componentDecorator={(
                          decoratedHref,
                          decoratedText,
                          key
                        ) => (
                          <a
                            target={
                              decoratedHref.includes("mailto") ? "" : "blank"
                            }
                            href={decoratedHref}
                            key={key}
                          >
                            {decoratedText}
                          </a>
                        )}
                      >
                        <div className="message-text">{con.message}</div>
                      </Linkify>
                    </div>
                    <br />
                  </div>
                ))}
                <div ref={messagesEnd}></div>
              </div>
            )}
            <div className="chat-footer" hidden={request.closedDate}>
              <textarea
                onChange={($event) => {
                  setMessage($event.target.value);
                }}
                value={message}
                className="send-message-text"
              ></textarea>
              {/* <label className="upload-file">
                <input
                  onChange={(e) => onChangeFile(e)}
                  type="file"
                  required=""
                />
                <i className="fa fa-paperclip"></i>
              </label> */}
              <button
                disabled={isSending}
                onClick={sendMessage}
                type="button"
                className="send-message-button"
              >
                {" "}
                <i className="fa fa-paper-plane"></i>{" "}
              </button>
            </div>
          </div>
        </div>
      </Container>
      <AlertModal
        show={showSuccess}
        handleClose={handleCloseSuccess}
        modalBody={"Message has been successfully sent."}
        handleConfirmButton={handleCloseSuccess}
        confirmButton={"Close"}
      ></AlertModal>
      <AlertModal
          show={showError}
          handleClose={handleCloseError}
          modalTitle={'Issue/Request Error'}
          modalBody={"You encountered an error, please let your EssilorLuxottica representative know by copying and sharing the response below. The EssilorLuxottica representative will then notify IT and share your details to a member of the Medical Affairs team will then directly contact you within 14 calendar days."}
          errorMessage={errorMessage}
          handleConfirmButton={handleCloseError}
          confirmButton={'Close'}>
      </AlertModal>
    </>
  );
};

export default Conversation;
